(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('PlatformRentalRegistrationsController', PlatformRentalRegistrationsController)

    PlatformRentalRegistrationsController.$inject = ['$uibModal', '$filter', 'virtualfairs', 'ExpoService', 'VirtualFairService', 'AclService', 'toastr', 'isPlatformRental'];


    function PlatformRentalRegistrationsController($uibModal, $filter, virtualfairs, ExpoService, VirtualFairService, AclService, toastr, isPlatformRental) {
        var vm = this;


        vm.approvedList             = '';
        vm.queryFlag                = false;
        vm.expo                     = '';
        vm.expoSelected             = '';
        vm.seller                   = '';
        vm.sellerSelected           = '';
        
        vm.countResult              = 0;
        vm.countUniversity          = 0;
        vm.countAgent               = 0;
        vm.countGovernment          = 0;
        vm.countOther               = 0;
        vm.boothInfoCheckSelected   = -1;
        vm.boothInfoSelected        = [];
        vm.expo                     = virtualfairs;
        vm.getByFilter              = getByFilter;
        vm.openInfoModal            = openInfoModal;
        vm.checkCourseStatus        = checkCourseStatus;
        vm.checkApprovedPrograms    = checkApprovedPrograms;
        vm.downloadCSV              = downloadCSV;
        vm.hubLogin                 = hubLogin;
        vm.syncBooth                = syncBooth;
        vm.canSync                  = false;
        vm.isPlatformRental         = isPlatformRental;

        vm.boothInfoOptions = [
            {id: 'representatives', name: 'Representatives'},
            {id: 'booth', name: 'Booth'},
            {id: 'videos', name: 'Videos'},
            {id: 'albums', name: 'Album'},
            {id: 'brochures', name: 'Brochures'},
            {id: 'nationalities', name: 'Nationalities Block'},
            {id: 'branches', name: 'Branches'},
            // {id: 'programs', name: 'Programs'},
        ];
        vm.boothInfoCheckOptions   = [
            {id: -1, name: 'No'},
            {id: 1, name: 'Yes, with selected information'},
            {id: 0, name: 'Yes, without information'}
        ];

        function activate() {
            // 
        }

        function openInfoModal(ApprovedItem, type) {
            var template = '';
            var items    = '';
            let filter = {};
            filter['id'] = ApprovedItem.id;
            if(type == 'albums') {
                template = 'templates/virtualfairs/approved/info/album_template.modal.html';
                VirtualFairService.getAlbums(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'albums';
                            },
                            setMaxRepresentatives: function () {
                                return false;
                            }

                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'videos'){
                template = 'templates/virtualfairs/approved/info/video_template.modal.html';
                VirtualFairService.getVideos(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'videos';
                            },
                            setMaxRepresentatives: function () {
                                return false;
                            }
                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'booths'){
                template = 'templates/virtualfairs/approved/info/booth_template.modal.html';
                VirtualFairService.getBooths(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'videos';
                            },
                            setMaxRepresentatives: function () {
                                return false;
                            }
                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'brochures'){
                template = 'templates/virtualfairs/approved/info/brochure_template.modal.html';
                VirtualFairService.getBrochures(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'brochures';
                            },
                            setMaxRepresentatives: function () {
                                return false;
                            }
                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'nationalities'){
                template = 'templates/virtualfairs/approved/info/nationality_template.modal.html';
                VirtualFairService.getNationalities(filter).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedController',
                        controllerAs:'vm',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'nationalities';
                            },
                            setMaxRepresentatives: function () {
                                return false;
                            }
                        }
                    });
                }).catch(function(err) {

                });
            }

            if(type == 'representatives'){
                template = 'templates/virtualfairs/approved/info/representative_template.modal.html';

                    items = ApprovedItem.representatives;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalApprovedController',
                        controllerAs:'vm',
                        size: 'lg',
                        resolve:
                        {
                            ApprovedItem      : function () {
                                return items;
                            },
                            expoUserVirtualFairID : function () {
                                return ApprovedItem.id
                            },
                            item: function () {
                                return ApprovedItem
                            },
                            type      : function () {
                                return 'representatives';
                            },
                            setMaxRepresentatives: function () {
                                return false;
                            }
                        }
                    });
            }

            if(type == 'program_types') {
                template = 'templates/virtualfairs/approved/info/program_types.modal.html';
                $uibModal.open({
                    templateUrl: template,
                    controller: 'InfoModalApprovedController',
                    controllerAs:'vm',
                    resolve:
                    {
                        ApprovedItem      : function () {
                            return ApprovedItem;
                        },
                        expoUserVirtualFairID : function () {
                            return ApprovedItem.id
                        },
                        item: function () {
                            return ApprovedItem
                        },
                        type: function () {
                            return [
                                {alias: 'language', name: 'Language', full_name: 'Language Courses'},
                                {alias: 'university', name: 'Undergrad', full_name: 'Undergraduate/Community College/Technical'},
                                {alias: 'boarding', name: 'Secondary', full_name: 'Secondary'},
                                {alias: 'extension', name: 'Short-Term', full_name: 'Extension / Certificate / Diploma'},
                                {alias: 'graduate', name: 'Postgrad', full_name: 'Graduate/Postgraduate'},
                                {alias: 'mba', name: 'MBA', full_name: 'MBA Program'},
                                {alias: 'online', name: 'Online', full_name: 'Online Distance Learning'},
                                {alias: 'vocational', name: 'Vocational', full_name: 'Vocational/ Career / Technical'}
                            ]
                        },
                        setMaxRepresentatives: function () {
                            return false;
                        }
                    }
                });
            }

            if(type == 'branches') {
                template = 'templates/virtualfairs/approved/info/branches.modal.html';
                $uibModal.open({
                    templateUrl: template,
                    controller: 'InfoModalApprovedController',
                    controllerAs:'vm',
                    resolve:
                    {
                        ApprovedItem: function () {
                            return ApprovedItem;
                        },
                        expoUserVirtualFairID : function () {
                            return ApprovedItem.id
                        },
                        item: function () {
                            return ApprovedItem
                        },
                        type: function () {
                            return 'branches';
                        },
                        setMaxRepresentatives: function () {
                            return false;
                        }
                    }
                });
            }
        }

        function getByFilter() {
            vm.query = {};

            if(vm.isPlatformRental) {
                vm.query['platform-rental'] = 1;
            }

            if(typeof vm.sellerSelected !== 'undefined' &&  vm.sellerSelected.name !== 'All') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            if(vm.boothInfoCheckSelected != -1) {
                vm.query['booth_info_check'] = vm.boothInfoCheckSelected;
                if(vm.boothInfoSelected.length) {
                    vm.query['booth_info'] = JSON.stringify(vm.boothInfoSelected);
                }
            }

            VirtualFairService.getByFilterApproved(vm.query).then(function(response){
                vm.approvedList    = response.data.data;
                vm.queryFlag       = true;
                vm.countUniversity = response.data.countType[0].university;
                vm.countAgent      = response.data.countType[0].agent;
                vm.countGovernment = response.data.countType[0].government;
                vm.countOther      = response.data.countType[0].other;
                vm.countResult     = Object.keys(response.data.data).length;
                vm.checkApprovedPrograms();

            }).catch(function(err) {
            });
        }

        function checkApprovedPrograms() {
            angular.forEach(vm.approvedList, function(approved) {            
                vm.checkCourseStatus(approved);
            });
        }
    
        function checkCourseStatus(approved) {
            approved.programTypesPending = false;   
            approved.programTypesProgramPending = false;
            approved.hasProgramTypes = false;
            approved.hasType = {
                language : {
                    hasCourse: false,
                    isPending: false,
                },
                university : {
                    hasCourse: false,
                    isPending: false,
                },
                extension : {
                    hasCourse: false,
                    isPending: false,
                },
                graduate : {
                    hasCourse: false,
                    isPending: false,
                },
                online : {
                    hasCourse: false,
                    isPending: false,
                },
                vocational : {
                    hasCourse: false,
                    isPending: false,
                },
                mba : {
                    hasCourse: false,
                    isPending: false,
                },
                boarding : {
                    hasCourse: false,
                    isPending: false,
                },
            };
            
            if(approved.hasOwnProperty('profile') && approved.profile.profile_types != 'undefined') {
                angular.forEach(approved.profile.profile_types, function(value) {          
                    if(approved.type == 'university' || approved.type == 'agent') {
                        approved.hasProgramTypes = true;
                        if (!approved.profile.profile_types || approved.profile.profile_types.length == 0) {
                            approved.programTypesPending = true;
                        }
                        if(value.profile_type.alias == 'language') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.language_program_languages_taught.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'university') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.university_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'extension') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if(approved.profile.extension_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'graduate') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.graduate_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if (value.profile_type.alias == 'online') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if (approved.profile.online_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if(value.profile_type.alias == 'vocational') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                            if(approved.profile.vocational_program_courses_offered.length == 0) {
                                approved.programTypesProgramPending = true;
                                approved.hasType[value.profile_type.alias].isPending = true;
                            }
                        } else if(value.profile_type.alias == 'mba') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                        } else if(value.profile_type.alias == 'boarding') {
                            approved.hasType[value.profile_type.alias].hasCourse = true;
                        }
                    }
                });
            }
        }

        function syncBooth(virtual_fair_id, platform_fair_id, expo_virtual_fair_user_id) {
 
            VirtualFairService.platformSyncExec(
                virtual_fair_id,
                platform_fair_id,
                'exhibitors',
                expo_virtual_fair_user_id
            ).then(function(response){
                if (response.data.error) {
                    toastr.error('Sorry! There was an error.');
                } else {
                    toastr.success('The booth was successfully synchronized!');
                }
            });
        
        }

        function downloadCSV() {
            vm.query = {};

            if(vm.isPlatformRental) {
                vm.query['platform-rental'] = 1;
            }

            if(typeof vm.sellerSelected !== 'undefined' &&  vm.sellerSelected.name !== 'All') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            if(vm.boothInfoCheckSelected != -1) {
                vm.query['booth_info_check'] = vm.boothInfoCheckSelected;
                if(vm.boothInfoSelected.length) {
                    vm.query['booth_info'] = JSON.stringify(vm.boothInfoSelected);
                }
            }
            VirtualFairService.getByFilterApprovedCSV(vm.query).success(function (data) {
              var anchor = document.createElement("a");
              anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
              anchor.target = "_blank";
              anchor.download = `virtual_fair_approved_${vm.virtualFairSelected}.csv`;
              document.body.appendChild(anchor);
              anchor.click();
              $timeout(function () {
                anchor.remove();
              }, 50);
            });
        }

        function hubLogin(item) {
            let url = `https://hub.fpp.world/login/token/${item.user.email}/${item.user.token}?virtual_fair_id=${item.virtual_fair_id}`
            window.open(url, '_blank')
        }

        activate();
    }    

})();